import { computed, shallowRef } from 'vue';
import { useNotesStore } from '@/stores/notes';

export function useNotes(context, notesParams) {
  const notesStore = useNotesStore();
  const isNotesLoading = shallowRef(false);

  const getAllNotes = computed(() => {
    const { id } = notesParams;
    return notesStore.getNotes({ id, context });
  });

  const getNotes = computed(() => {
    const { id } = notesParams;
    return notesStore.getNotes({ id, context });
  });

  async function postNewNote({ message }) {
    isNotesLoading.value = true;
    await notesStore.postNote({ params: { ...notesParams, message, context } });
    isNotesLoading.value = false;
  }

  async function fetchAllNotes() {
    isNotesLoading.value = true;
    const { id } = notesParams;
    await notesStore.fetchNotes({
      params: {
        id,
        context,
      },
    });
    isNotesLoading.value = false;
  }

  async function deleteCurrentNote({ noteId }) {
    isNotesLoading.value = true;
    const { id } = notesParams;
    await notesStore.deleteNote({
      params: {
        id,
        context,
        noteId,
      },
    });
    isNotesLoading.value = false;
  }

  async function updateCurrentNote({ message, note }) {
    isNotesLoading.value = true;
    const { id } = notesParams;

    await notesStore.updateNote({
      params: {
        id,
        context,
        message,
        noteId: note._id,
      },
    });
    isNotesLoading.value = false;
  }

  return {
    isNotesLoading,
    getAllNotes,
    getNotes,
    postNewNote,
    fetchAllNotes,
    deleteCurrentNote,
    updateCurrentNote,
  };
}
